import React, { useState } from 'react'
import { useNavigate } from 'react-router'
import OnboardingLayout from './OnboardingLayout/OnboardingLayout'
import SalesText from '../../components/_atoms/SalesText/SalesText'
import { colors, fontSizes, fontWeights } from '../../constants/salesStyles'
import SalesButton from '../../components/_atoms/SalesButton/SalesButton'
import { adminRouteAlias, getAdminNavigationPath } from '../../router/adminRouteAlias'
import { useDispatch } from '../../modules/store/customDispatch'
import updateUserTaskResult from '../../modules/redux/tasksService/UpdateUserTaskResult'
import { useSelector } from '../../modules/store/customSelector'
import createUserTaskResult from '../../modules/redux/tasksService/CreateUserTaskResult'

const Onboarding = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const onboardingTask = useSelector(state => state.userData.tasksInfo?.onboarding)

    const [isIframeLoaded, setIsIframeLoaded] = useState(false)

    const handleOnboardingDone = () => {
        if (onboardingTask) {
            if (onboardingTask.status !== 'done') {
                dispatch(updateUserTaskResult({ code: 'onboarding', userTaskId: onboardingTask.id, status: 'done' }))
            }
        } else {
            dispatch(createUserTaskResult({ code: 'onboarding', status: 'done' }))
        }
    }

    return (
        <OnboardingLayout>
            {/* Заголовок */}
            <div className="mb-3 col-md-7 text-start">
                <SalesText
                    text="Добро пожаловать!"
                    fontWeight={fontWeights.bold}
                    fontSize={fontSizes.xxl}
                />
            </div>

            {/* Описание */}
            <div className="mb-3 col-md-7 text-start">
                <SalesText
                    text="Наша программа поможет вам быстро начать работу с базой запчастей: вручную или через импорт из внешней системы."
                    fontWeight={fontWeights.normal}
                    fontSize={fontSizes.s}
                />
                <SalesText
                    text="Посмотрите короткое видео о возможностях системы, а затем выберите удобный способ старта."
                    fontWeight={fontWeights.normal}
                    fontSize={fontSizes.s}
                    marginTopPixels={12}
                />
            </div>

            {/* Контент: видео + блоки */}
            <div className="row">
                {/* Левая колонка — видео */}
                <div className="col-md-7 mb-4 position-relative">
                    {!isIframeLoaded && (
                        <div
                            className="w-100 mb-3 rounded"
                            style={{
                                height: '405px',
                                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                                backgroundSize: '200% 100%',
                                animation: 'loading 1.4s ease infinite',
                                borderRadius: '8px'
                            }}
                        />
                    )}
                    <iframe
                        width="100%"
                        height="405"
                        src="https://rutube.ru/play/embed/ba57c2472cff8dda98e83406ebf4cd73/"
                        frameBorder="0"
                        allow="clipboard-write; autoplay"
                        allowFullScreen
                        onLoad={() => setIsIframeLoaded(true)}
                        style={{ display: isIframeLoaded ? 'block' : 'none', borderRadius: '8px' }}
                    />
                </div>

                {/* Правая колонка — блоки */}
                <div className="col-md-5 d-flex flex-column gap-3 text-start">
                    {/* Блок 1: Ручное внесение */}
                    <div
                        className="p-3 rounded"
                        style={{
                            backgroundColor: '#f0f6ff',
                            border: `1px solid ${colors.blue}`,
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                        }}
                    >
                        <SalesText
                            text="Ручное внесение"
                            fontWeight={fontWeights.bold}
                            fontSize={fontSizes.m}
                            marginBottomPixels={8}
                        />
                        <SalesText
                            text="Создавайте запчасти вручную."
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                            marginBottomPixels={12}
                        />
                        <SalesButton
                            backgroundColor={colors.blue}
                            paddingVerticalPixels={8}
                            className="w-100 justify-content-center"
                            onClick={() => {
                                handleOnboardingDone()
                                navigate(getAdminNavigationPath(adminRouteAlias.newPart.location))
                            }}
                        >
                            <SalesText text="Выбрать" color={colors.white} fontSize={fontSizes.xs} />
                        </SalesButton>
                    </div>

                    {/* Блок 2: Импорт */}
                    <div
                        className="p-3 rounded"
                        style={{
                            backgroundColor: '#f3f8f4',
                            border: `1px solid ${colors.blue}`,
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                        }}
                    >
                        <SalesText
                            text="Импорт базы"
                            fontWeight={fontWeights.bold}
                            fontSize={fontSizes.m}
                            marginBottomPixels={8}
                        />
                        <SalesText
                            text="Поможем перенести из вашей системы учета"
                            fontWeight={fontWeights.normal}
                            fontSize={fontSizes.xs}
                            marginBottomPixels={12}
                        />
                        <SalesButton
                            backgroundColor={colors.blue}
                            paddingVerticalPixels={8}
                            className="w-100 justify-content-center"
                            onClick={() =>
                                navigate(getAdminNavigationPath(adminRouteAlias.onboardingDownloadFromFile.location))
                            }
                        >
                            <SalesText text="Добавить" color={colors.white} fontSize={fontSizes.xs} />
                        </SalesButton>
                    </div>
                </div>
            </div>
        </OnboardingLayout>
    )
}

export default Onboarding
